import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';
import VersionBox from '../../components/common/VersionBox';
import i18n from '../../i18n';
import PageBreak from '../../components/structure/PageBreak';
import ChmsIntegration from './ChmsIntegration';
import ShareFaithIntegration from './ShareFaithIntegration';
import LiveStreamingIntegration from './LiveStreamingIntegration';
import StudioCIntegration from './StudioCIntegration';
import appStateProvider from "../../utilities/appStateProvider";
import { ENVIRONMENT } from '../../utilities/constants';

class Integrations extends React.Component {
    componentDidMount() {
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.versions.publishProgress && this.props.versions.publishProgress) {
            this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
            this.props.actions.getProjectVersion(this.props.match.params.projectId);
        }
    }

    hideChmsToggleForUnityCustomers(){
        const isUnity = localStorage.getItem('IsUnity');
        if (isUnity === 'true'){
            return 'chms-integrations-hidden';
        }
        return 'chms-integrations-legacy';
    }

    render() {
        const chmsIntegrationsDiv = this.hideChmsToggleForUnityCustomers(); 
        const version = this.props.versions.select;
        const appState = appStateProvider();
        const environment = appState.getActiveEnvironment();
        
        return (
            <VersionBox
                name={version.name}
                versionNumber={version.version}
                saving={this.props.versions.inProgress}
                justSaved={this.props.projects.justSaved}
                menuSection="AppSettings"
                menuItem="Integrations"
                previewCssClass="app-settings_general-info"
                configCode={version.configCode}
                showPreview={true}
            >
                <div id="integrations" className="content-inside">
                    <h1 id="integrations-header">{i18n.t('integrations.header')}</h1>
                    <p id="integrations-subhead" className="lead">{i18n.t('integrations.subtitle')}</p>
                    {!this.props.versions.inProgress
                    && this.props.flags.results?.shareFaithDevotionals
                    && <ShareFaithIntegration /> }
                    <div className={chmsIntegrationsDiv}>
                        {!this.props.versions.inProgress
                        && this.props.flags.results?.shareFaithDevotionals
                        && (this.props.flags.results?.chMSIntegration
                            || this.props.flags.results?.liveStreaming)
                        && <PageBreak />}
                        {!this.props.versions.inProgress
                        && this.props.flags.results?.chMSIntegration
                        && <ChmsIntegration />}
                        {!this.props.versions.inProgress
                        && this.props.flags.results?.chMSIntegration
                        && this.props.flags.results?.liveStreaming
                        && <PageBreak />}
                    </div>
                    {!this.props.versions.inProgress
                    && this.props.flags.results?.liveStreaming
                    && <LiveStreamingIntegration />}

                    {!this.props.versions.inProgress 
                        && this.props.flags.results?.chMSIntegration 
                        && this.props.flags.results?.studioC
                        && environment !== ENVIRONMENT.MY_PARISH_SOFT // NOT AVAILABLE FOR myParishSoft
                        && <StudioCIntegration />}
                </div>
            </VersionBox>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Integrations);
